<header class="page-header">
  <div class="page-header__row">
    <h1>Compare filings</h1>
    <span class="badge">Beta</span>
  </div>
  <p class="lede">Upload two XBRL filings to view differences and export a diff Excel report.</p>
</header>

<p class="notice">Coming soon — diff viewer and Excel export are on the roadmap.</p>

<app-file-upload-zone
  label="Two XBRL filings"
  [multiple]="true"
  [disabled]="true"
  (filesSelected)="onFiles($event)"
/>
